import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Geocode from 'react-geocode'
import { getRegions, saveNewRegion, deleteRegion, updateRegion } from '../../../actions/company'

import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import MemberProfileContainer from '../../../components/MemberProfile/MemberProfileContainer'
import { openSuccessMessage, openErrorMessage } from '../../../actions/message'
import { isValidString } from '../../../utils/string'

class MemberProfile extends PureComponent {
  componentDidMount() {
    Geocode.setApiKey('AIzaSyBe4ZKdGYJv3zwOaMpyseVAURvHk19WFb4')
    this.props.dispatch(getRegions())
  }

  validateRegion = (region) => {
    if (!isValidString(region.name)) {
      this.props.dispatch(openErrorMessage('Please enter the name of the region'))
      return false
    }
    /* if(!region.zipCodes || !region.zipCodes.length) {
            this.props.dispatch(openErrorMessage('Please enter the zipcodes for the region'));
            return false;
        } */
    return true
  }

  onSave = (region, afterSave) => {
    let actionToHit = null

    if (this.validateRegion(region)) {
      if (region.id) {
        actionToHit = updateRegion
      } else {
        actionToHit = saveNewRegion
      }
      return new Promise((resolve, reject) => {
        this.props
          .dispatch(actionToHit(region))
          .then((res) => {
            resolve(res)
            afterSave && afterSave()
            this.props.dispatch(openSuccessMessage('Region saved successfully'))
            this.props.dispatch(getRegions())
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }

  onDelete = (region) => {
    this.props.dispatch(deleteRegion(region.id)).then((res) => {
      this.props.dispatch(openSuccessMessage('Region deleted successfully'))
      this.props.dispatch(getRegions())
    })
  }

  render() {
    const { regions = {}, lastModified } = this.props.companyReducer
    const regionValues = (regions && regions.values) || []

    return (
      <div>
        <MemberProfileContainer
          regions={regionValues || []}
          lastModified={lastModified}
          Geocode={Geocode}
          onDelete={this.onDelete}
          onSave={this.onSave}
        />
      </div>
    )
  }
}

export default connect(({ dispatch, shopReducer, companyReducer, authReducer }) => ({
  dispatch,
  shopReducer,
  companyReducer,
  authReducer,
}))(ContainerWithTitle(MemberProfile, 'Member Profile Settings'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/MemberProfile.js